/*
 *
 * PardotVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/SalesforceVerify';

/*
 * @dev defineApiActionTypes a function that
 * return concat base with START,SUCCESS,FAILURE
 */
export const VERIFY_PARDOT = defineApiActionTypes(`${prefix}/VERIFY_PARDOT_START`);
